import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


export class HttpErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestWithCredentials = request.clone({ withCredentials: true });

    return next.handle(requestWithCredentials)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          if (error.error instanceof Object) {
              console.log('This is client side error');
              errorMsg = `${error.error.message}`;
          } else {
              console.log('This is server side error');
              errorMsg = `${error.message}`;
          }
          console.log(errorMsg);
          return throwError(errorMsg);
      })
      )
  }
}
